<template>
  <div class="cooperation-page">
    <div class="page-header">
      <el-page-header @back="$router.go(-1)">
        <template #content>
          <div class="page-title">技术合作</div>
        </template>
      </el-page-header>
    </div>

    <div class="form-container">
      <el-form 
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-position="top"
        class="cooperation-form"
      >
        <div class="form-section">
          <h3 class="section-title">基本信息</h3>
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="formData.companyName" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          
          <el-form-item label="联系人" prop="contactName">
            <el-input v-model="formData.contactName" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="formData.phone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="formData.email" placeholder="请输入电子邮箱"></el-input>
          </el-form-item>
        </div>

        <div class="form-section">
          <h3 class="section-title">公司信息</h3>
          <el-form-item label="公司类型" prop="companyType">
            <el-select v-model="formData.companyType" placeholder="请选择公司类型" style="width: 100%">
              <el-option label="科技公司" value="tech"></el-option>
              <el-option label="互联网公司" value="internet"></el-option>
              <el-option label="软件公司" value="software"></el-option>
              <el-option label="硬件公司" value="hardware"></el-option>
              <el-option label="其他" value="other"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="公司规模" prop="companySize">
            <el-select v-model="formData.companySize" placeholder="请选择公司规模" style="width: 100%">
              <el-option label="1-50人" value="small"></el-option>
              <el-option label="51-200人" value="medium"></el-option>
              <el-option label="201-500人" value="large"></el-option>
              <el-option label="500人以上" value="enterprise"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="技术领域" prop="techFields">
            <el-select 
              v-model="formData.techFields" 
              multiple 
              placeholder="请选择技术领域" 
              style="width: 100%"
            >
              <el-option label="人工智能" value="ai"></el-option>
              <el-option label="大数据" value="bigdata"></el-option>
              <el-option label="物联网" value="iot"></el-option>
              <el-option label="云计算" value="cloud"></el-option>
              <el-option label="区块链" value="blockchain"></el-option>
              <el-option label="其他" value="other"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="form-section">
          <h3 class="section-title">合作意向</h3>
          <el-form-item label="合作方式" prop="cooperationType">
            <el-checkbox-group v-model="formData.cooperationType">
              <el-checkbox label="API对接">API对接</el-checkbox>
              <el-checkbox label="SDK集成">SDK集成</el-checkbox>
              <el-checkbox label="系统开发">系统开发</el-checkbox>
              <el-checkbox label="技术咨询">技术咨询</el-checkbox>
              <el-checkbox label="其他">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          
          <el-form-item label="技术需求" prop="techRequirements">
            <el-input 
              v-model="formData.techRequirements" 
              type="textarea" 
              :rows="3" 
              placeholder="请描述您的技术需求"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="备注说明" prop="remarks">
            <el-input 
              v-model="formData.remarks" 
              type="textarea" 
              :rows="4" 
              placeholder="请详细描述您的合作需求和期望"
            ></el-input>
          </el-form-item>
        </div>

        <div class="form-actions">
          <el-button type="primary" @click="submitForm" :loading="submitting">提交申请</el-button>
          <el-button @click="resetForm">重置</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'

export default {
  name: 'TechCooperation',
  setup() {
    const formRef = ref(null)
    const submitting = ref(false)
    
    const formData = reactive({
      companyName: '',
      contactName: '',
      phone: '',
      email: '',
      companyType: '',
      companySize: '',
      techFields: [],
      cooperationType: [],
      techRequirements: '',
      remarks: ''
    })
    
    const formRules = {
      companyName: [
        { required: true, message: '请输入公司名称', trigger: 'blur' }
      ],
      contactName: [
        { required: true, message: '请输入联系人姓名', trigger: 'blur' }
      ],
      phone: [
        { required: true, message: '请输入联系电话', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
      ],
      email: [
        { required: true, message: '请输入电子邮箱', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
      ],
      companyType: [
        { required: true, message: '请选择公司类型', trigger: 'change' }
      ],
      companySize: [
        { required: true, message: '请选择公司规模', trigger: 'change' }
      ],
      techFields: [
        { required: true, message: '请至少选择一个技术领域', trigger: 'change' }
      ],
      cooperationType: [
        { required: true, message: '请至少选择一种合作方式', trigger: 'change' }
      ]
    }
    
    const submitForm = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          submitting.value = true
          // 这里添加提交表单的API调用
          setTimeout(() => {
            ElMessage.success('提交成功，我们将尽快与您联系')
            resetForm()
            submitting.value = false
          }, 1000)
        }
      })
    }
    
    const resetForm = () => {
      formRef.value.resetFields()
    }
    
    return {
      formRef,
      formData,
      formRules,
      submitting,
      submitForm,
      resetForm
    }
  }
}
</script>

<style scoped>
.cooperation-page {
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  background-color: #fff;
  padding: 15px;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.page-title {
  font-size: 16px;
  font-weight: 500;
}

.form-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.cooperation-form {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.form-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin: 0 0 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.form-actions {
  text-align: center;
  margin-top: 30px;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}
</style> 